// @flow
import styled from 'styled-components';
import { ListItem } from '../ListItem';

export const ListUnstyled = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  > ${ListItem} {
    &:not(:last-child){
      border-bottom ${({ innerBorder }) => innerBorder};
    }
  }
`;
